<template>
  <modal id="loader-connect-a2z" :show="true">
    <div class="loader-and-logo mb-20">
      <Icon icon-key="loader" class="infinite-loader" :size="92" />
      <Icon icon-key="brand-logo-short" class="brand-short-logo" :size="35" />
    </div>
    <p class="font-size-24">{{ title }}</p>
  </modal>
</template>

<script>
export default {
  name: 'LoaderPage',
  props: ['title']
}
</script>

<style scoped lang="scss">
@import '@/assets/sass/base/vars.scss';

#loader-connect-a2z {
  background-image: linear-gradient(#fff3e0, $color-green);

  .loader-and-logo {
    position: relative;
    text-align: center;
  }

  .brand-short-logo {
    position: absolute;
    right: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .infinite-loader {
    margin: auto;
    animation-name: rotate;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes rotate {
    from {
      transform: rotate(-360deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
